var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-inner"},[_c('v-btn',{attrs:{"color":"mainColorLight","x-large":"","block":"","depressed":""},on:{"click":_vm.gotoSignIn}},[_vm._v(" 회원가입 ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }